module.exports = value => {
	return !value;
}
